import { FormattedVerificationTransactionDetailsScore, VerificationTransactionDetailsScore } from "@idw-types/data/verification-transaction-details";
import { safelyParseIntFromString } from "@utils/string-util";

export const formatVerificationTransactionDetailsScores = (
    scores: Array<VerificationTransactionDetailsScore>
): Array<FormattedVerificationTransactionDetailsScore> => {
    return scores.map(score => formatVerificationTransactionDetailsScore(score));
};

export const formatVerificationTransactionDetailsScore = (
    score: VerificationTransactionDetailsScore
): FormattedVerificationTransactionDetailsScore => {
    let date = null;
    if (score.date) {
        date = new Date(parseInt(score.date));
    }

    return {
        attempt: score.attempt,
        date: date,
        id: score.id,
        score: safelyParseIntFromString(score.score),
        scoreType: score.scoreType
    };
};